import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import { Link } from "react-router-dom";
import { Accordion, Form, Button, Modal } from "react-bootstrap";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/bootstrap.css';
import "./CheckOutCall.css";
import API from '../../Utils/Api';
import loader from '../../assests/loader.gif';
import {validateproductcheckout} from '../../Utils/validate';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from './CheckoutForm';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const CheckOutCall = () => {
  const navigate = useNavigate();
  const location = useLocation();
   const [loading,setLoading] = useState(true);
  const [errors,setErrors] = useState({});

  const [inputsche,setInputsche] = useState({email:'',first_name:'',last_name:'', country_code: '+353',mobile_number:'', full_mobile_number: '',country_id:'105',county:'',address:'',postcode:'',product_amount:0,product_vat:0,product_vat_per:0,is_ireland:0,shipping_within_ireland:0,international_shipping:0,grand_total:0,product_id:'',qty:0,location:'',gender:'',birth_year:'',location_name:'', single_event: false});

  const [inputs,setInputs] = useState({});
  const [qty, setQty] = useState(1);

  const [country, setCountry]=useState([]);

  const [loc, setLoc]=useState([]);

  const [showFirst, setShowFirst] = useState(false);
  const [activeKey, setActiveKey] = useState("0");


  const [isEditing, setIsEditing] = useState(true);

  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 3;

  const step1 = () => {
      const validationErrors = validateproductcheckout(inputsche);
      const noErrors = Object.keys(validationErrors).length === 0;
      setErrors({});
      setErrors(validationErrors);
      if(noErrors){
        setActiveKey("1");
        setIsEditing(false);
      }
  }

const nextStep1 = () => {
  const validationErrors = validateproductcheckout(inputsche);
      const noErrors = Object.keys(validationErrors).length === 0;
      setErrors({});
      setErrors(validationErrors);
      if(noErrors){
        if (currentStep < totalSteps) setCurrentStep(currentStep + 1);
        setActiveKey("1");
      }
};

  const nextStep = () => {
    if (currentStep < totalSteps) setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

  useEffect(() => {
    document.title = `CheckOut Call | Your Friend My Friend`;
    document.getElementById('bodywrap').className = 'checkout';

    const state = location.state;

      if (!state || !state.inputs || !state.qty) {
        navigate('/call-me-card');
        return;
      }
      setInputs(state.inputs);
      setQty(state.qty);

      /* Start get location data */
    API.get('get_location')
      .then(response => {
      if(response.data.status === false){
        
      }else{
         setLoc(response.data.data);
      }                  
    }).catch(error => {
       
    });  
   /* End get location data */

      /* Start get country data */
      API.post('get_product_country')
        .then(response => {
          setLoading(false);
        if(response.data.status === false){
          
        }else{
           setCountry(response.data.data);
        }                  
      }).catch(error => {
          setLoading(false);
      });  
     /* End get country data */
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

/* Start Value set */
const handleInputChange = (event) => {
      event.persist();    
      setInputsche(inputsche => ({...inputsche, [event.target.name]: event.target.value})); 
}

const handleInputChangeLocation = (e) => {
  const selectedOption = e.target.options[e.target.selectedIndex];
  const locationName = selectedOption.getAttribute("data-name");

  setInputsche(prev => ({
    ...prev,
    location: e.target.value,   // id
    location_name: locationName,   // name
  }));
};

const handleInputChangeCustom = (field, value) => {
    setInputsche({ ...inputsche, [field]: value })
  }

const handleInputChangeCountry = (event) => {
  const { name, value } = event.target;

  setInputsche(prev => ({
    ...prev,
    [name]: value
  }));

  setInputs(prev => {
    let shipping = 0;
    let shipping_text = '';

    if (Number(value) === 105 || Number(value) === 232) {
      shipping = parseFloat(prev.shipping_within_ireland) || 0;
      shipping_text = 'Shipping within Ireland';
    } else {
      shipping = parseFloat(prev.international_shipping) || 0;
      shipping_text = 'International Shipping';
    }

    const total_price = parseFloat(prev.total_price) || 0;
    const vat_total = parseFloat(prev.vat_total) || 0;

    const grand_total = total_price + vat_total + shipping;

    return {
      ...prev,
      shipping,
      shipping_text,
      grand_total
    };
  });
};


  return (
    <>
      <div className="container-fluid out d-none d-md-block">
        <div className="text-left mb-5" onClick={() => { setShowFirst(true); }} style={{ cursor: "pointer" }}>
          <img src="/assests/images/back-top-logo.png" alt="back-logo" />
        </div>
        <div className="row">
          <div className="col-md-7">
            <Accordion activeKey={activeKey}>
              <Accordion.Item eventKey="0">
                <Accordion.Header onClick={() => setActiveKey("0")}>
                  <div className="w-100">
                    <div className="w-100 mb-3">1. Contact information</div>
                    {!isEditing && (
                      <div className="d-flex justify-content-between align-items-center after">
                        <span>{inputsche.email || "Enter your email"}</span>
                        <Button
                          className=""
                          variant="link"
                          onClick={() => {
                            setIsEditing(true);
                            setActiveKey("0");
                          }}
                        >
                          Edit
                        </Button>
                      </div>
                    )}
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  {isEditing ? (
                    <Form>
                      <div className="row g-3 mb-3">
                        <div className="col-md-12">
                          <Form.Group controlId="email">
                            <Form.Label>Email *</Form.Label>
                            <Form.Control
                              type="text"
                              value={inputsche.email}
                              name="email"
                              onChange={handleInputChange}
                              placeholder="email"
                            />
                            {errors.email && (<p className="text-danger">{errors.email}</p>)}
                          </Form.Group>

                        </div>
                        </div>
                        <div className="row g-3">
                        <div className="col-md-6">
                          <Form.Group controlId="firstName">
                            <Form.Label>First name *</Form.Label>
                            <Form.Control
                              type="text"
                              value={inputsche.first_name}
                              placeholder="First Name"
                name="first_name"
                onChange={handleInputChange}
                            />
              {errors.first_name && (<p className="text-danger">{errors.first_name}</p>)}
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group controlId="lastName">
                            <Form.Label>Last Name *</Form.Label>
                            <Form.Control
                              type="text"
                              value={inputsche.last_name}
                              placeholder="Last Name"
                name="last_name"
                onChange={handleInputChange}
                            />
              {errors.last_name && (<p className="text-danger">{errors.last_name}</p>)}
                          </Form.Group>
                        </div>
                      </div>
                        <div className="row g-3 ">
                        <div className="col-md-12">
                          <Form.Group controlId="phone">
                            <Form.Label>Phone Number *</Form.Label>
                            <PhoneInput
                              type="text"
                              name="phone"
                              country={'ie'}
                              placeholder="Enter phone number"
                              inputProps={{
                                name: 'full_mobile_number',
                                required: true,
                                autoFocus: false,
                              }}
                              inputStyle={{ width: '100%' }}
                              value={inputs.full_mobile_number}
                              onChange={(value, countryData = {}, event) => {
                                const dialCode = countryData.dialCode || '';
                                // Remove dial code from the value (with '+' just to be safe)
                                let numberWithoutCode = value;
                                if (dialCode) {
                                  const cleanDial = `+${dialCode}`;
                                  if (value.startsWith(cleanDial)) {
                                    numberWithoutCode = value.slice(cleanDial.length);
                                  } else if (value.startsWith(dialCode)) {
                                    numberWithoutCode = value.slice(dialCode.length);
                                  }
                                }
                                setInputsche({ ...inputsche, country_code: `+${dialCode}`, mobile_number: numberWithoutCode, full_mobile_number: `+${dialCode}${numberWithoutCode}` })
                              }}
                            />
                            {errors.mobile_number && (<p className="text-danger">{errors.mobile_number}</p>)}
                          </Form.Group>
                        </div>
                        <div className="col-md-12">
                          <Form.Group controlId="country">
                            <Form.Label>Country *</Form.Label>
                            <select className="form-control custom-input" name="country_id" value={inputsche.country_id} onChange={handleInputChangeCountry}>
                                <option value="">Country</option>
                                {country.map((val, i) => (
                                <option value={val.id} data-name={val.name}>{val.name}</option>
                                ))}
                            </select>
                            {errors.country_id && (<p className="text-danger">{errors.country_id}</p>)}
                          </Form.Group>
                        </div>
                        <div className="col-md-12">
                          <Form.Group controlId="address">
                            <Form.Label>Street Address *</Form.Label>
                            <Form.Control
                              type="text"
                              value={inputsche.address}
                              name="address"
                              onChange={handleInputChange}
                              placeholder="Street Address"
                            />
                            {errors.address && (<p className="text-danger">{errors.address}</p>)}
                          </Form.Group>
                        </div>
                        <div className="col-md-12">
                          <Form.Group controlId="county">
                            <Form.Label>County *</Form.Label>
                            <Form.Control
                              type="text"
                              value={inputsche.county}
                              name="county"
                              onChange={handleInputChange}
                              placeholder="County"
                            />
                            {errors.county && (<p className="text-danger">{errors.county}</p>)}
                          </Form.Group>
                        </div>
                        
                        <div className="col-md-12">
                          <Form.Group controlId="postcode">
                            <Form.Label>Postcode *</Form.Label>
                            <Form.Control
                              type="text"
                              value={inputsche.postcode}
                              name="postcode"
                              onChange={handleInputChange}
                              placeholder="Post code"
                            />
                            {errors.postcode && (<p className="text-danger">{errors.postcode}</p>)}
                          </Form.Group>
                        </div>
                      </div>

                      <div className="row g-3 ">
                        <div className="col-md-12">
                          <div className="form-check mb-3 d-flex align-items-center sign-ghar mt-3 gap-0">
                            <input
                              type="checkbox"
                              className={`form-check-input`}
                              id="single_event"
                              value={inputsche.single_event ? '1' : ''}
                              checked={inputsche.single_event}
                              onChange={(event) => handleInputChangeCustom('single_event', event.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="single_event">
                              Keep me in the loop with email updates about upcoming YFMF singles events and news. See our <Link to="/privacy-policy" target="_blank" className="text-decoration-none pri-link">Privacy Policy</Link>.
                            </label>
                          </div>
                        </div>
                      </div>
                      {inputsche.single_event && (
                        <>
                        <div className="row g-3">
                          
                          <div className="col-md-12">
                            <Form.Group controlId="lastName">
                              <Form.Label>Location *</Form.Label>
                              <select className="form-control custom-input" name="location" value={inputsche.location} onChange={handleInputChangeLocation}>
                                <option value="">Location</option>
                                {loc.map((val, i) => (
                                <option value={val.id} data-name={val.name}>{val.name}</option>
                                ))}
                              </select>
                              {errors.location && (<p className="text-danger">{errors.location}</p>)}
                            </Form.Group>
                          </div>
                        </div>
                        <div className="row g-3 mt-1">
                          <div className="col-md-6">
                            <Form.Group controlId="firstName">
                              <Form.Label>Gender *</Form.Label>
                              <select className="form-control custom-input" name="gender" value={inputsche.gender} onChange={handleInputChange}>
                                <option value="">Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Non-binary">Non-binary</option>
                              </select>
                              {errors.gender && (<p className="text-danger">{errors.gender}</p>)}
                            </Form.Group>
                          </div>
                          <div className="col-md-6">
                            <Form.Group controlId="lastName">
                              <Form.Label>Birth Year *</Form.Label>
                              <select name="birth_year" id="birth_year" className="form-control custom-input" value={inputsche.birth_year} onChange={handleInputChange}>
                                <option value="">Birth Year </option>
                                {Array.from(
                                  { length: (new Date().getFullYear() - 19) - 1940 + 1 },
                                  (_, i) => 1940 + i
                                ).map((year) => (
                                  <option key={year} value={year}>
                                    {year}
                                  </option>
                                ))}
                            </select>
                              {errors.birth_year && (<p className="text-danger">{errors.birth_year}</p>)}
                            </Form.Group>
                          </div>
                        </div>
                        </>
                      )}



                      <Button
                        className="mt-4 w-100 ne"
                        onClick={step1}
                      >
                        Confirm - next step
                      </Button>
                    </Form>
                  ) : null}
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1">
                <Accordion.Header>2. Payment</Accordion.Header>
                <Accordion.Body>
                    <Elements stripe={stripePromise}>
                      <CheckoutForm inputs={inputs} inputsche={inputsche} qty={qty} />
                    </Elements>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>

          <div className="col-md-1"></div>

          <div className="col-md-4">
            <div className="card">
              <div className="card-body">
                <h5>Order Summary</h5>
                <p>
                 {qty} X {inputs.title}
                  <span className="float-end">€{Number(inputs.total_price || 0).toFixed(2)}</span>
                </p>
                
                <hr />
                <p>
                  Subtotal <span className="float-end">€{Number(inputs.total_price || 0).toFixed(2)}</span>
                </p>
                
                <p>
                   {23 || 0}% VAT <span className="float-end">€{Number(inputs.vat_total || 0).toFixed(2)}</span>
                </p>
                <p className="d-none">
                  {inputs.shipping_text} <span className="float-end">€{Number(inputs.shipping || 0).toFixed(2)}</span>
                </p>
                <hr />
                <h6>
                  Total <span className="float-end">€{Number(inputs.grand_total || 0).toFixed(2)}</span>
                </h6>
                <p className="text-end">Price includes tax</p>
                <hr />
                {/*<h6>Refund Policy</h6>
                <p className="text-muted">
                  Refunds up to 2 days before the event.
                </p>*/}
                <h4>
                  Total <span className="float-end">€{Number(inputs.grand_total || 0).toFixed(2)}</span>
                </h4>
              </div>
            </div>

            {/* <Button className="mt-4 ne" onClick={() => { setShowFirst(true); }}>
              Leave Checkout
            </Button> */}

          </div>
        </div>
      </div>

      <Modal
        show={showFirst}
        onHide={() => setShowFirst(false)}
        centered
        size="lg"
        className="newyesrt"
      >
        <div className="leav">
          <div className="close-btn" onClick={() => setShowFirst(false)}>
            <X size={30} />
          </div>
          <Modal.Body className="text-center p-4">
            <h4>Leave checkout?</h4>
            <p>
              Are you sure you want to leave checkout? <br></br>
              The item you’ve selected may not be available later
            </p>
            <div className="d-flex justify-content-center gap-2 noyle">
              <Button className="w-100 st" onClick={() => setShowFirst(false)}>STAY</Button>
              <Button className="w-100 le" onClick={() => {
                if (location.pathname === "/check-out-call" && currentStep === 1) {
                  navigate("/call-me-card");
                } else {
                  prevStep();
                  setShowFirst(false);
                }
              }}>
                LEAVE
              </Button>
            </div>
          </Modal.Body>
        </div>
      </Modal>

      {/* Mobile Step View */}
      <div className="d-block d-md-none">
        {/* Step Content */}
        {currentStep === 1 && (
          <div className="container-fluid out d-flex flex-column vh-100">
            <div className="row text-center mb-5">
              <img src="/assests/images/back-top-logo.png" alt="back-logo" />
            </div>

            <div className="row flex-grow-1">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body align-items-start">
                    <div className="hyy" onClick={() => { setShowFirst(true); }}>
                      <Link 
                        className="holo"
                      >
                        <img src="/assests/images/back.png" alt="Back" />
                      </Link>
                    </div>
                    <h5>Order Summary</h5>
                    <p>
                      {qty} {inputs.title}
                      <span className="float-end">€{Number(inputs.grand_total || 0).toFixed(2)}</span>
                    </p>
                    <hr />
                    <p>
                      Subtotal <span className="float-end">€{Number(inputs.total_price || 0).toFixed(2)}</span>
                    </p>
                    <p>
                      {23 || 0}% VAT <span className="float-end">€{Number(inputs.vat_total || 0).toFixed(2)}</span>
                    </p>
                    <p className="d-none">
                      {inputs.shipping_text} <span className="float-end">€{Number(inputs.shipping || 0).toFixed(2)}</span>
                    </p>
                    <hr />
                    <h6>
                      Total <span className="float-end">€{Number(inputs.grand_total || 0).toFixed(2)}</span>
                    </h6>
                    <p className="text-end">Price includes tax</p>
                    <hr />
                    {/*<h6>Refund Policy</h6>
                    <p className="text-muted">
                      Refunds up to 2 days before the event.
                    </p>*/}
                  </div>
                </div>
              </div>
            </div>

            <div className="row pb-4">
              <div className="col-md-12">
                <h4>
                  Total <span className="float-end">€{Number(inputs.grand_total || 0).toFixed(2)}</span>
                </h4>
                <Button
                  className="mt-4 w-100 ne"
                  onClick={() => {
                    nextStep();
                  }}
                >
                  CHECKOUT
                </Button>
              </div>
            </div>
          </div>
        )}

        {currentStep === 2 && (
          <div className="container-fluid out d-flex flex-column vh-100">
            <div className="row text-center mb-5">
              <img src="/assests/images/back-top-logo.png" alt="logo" />
            </div>

            <div className="row flex-grow-1">
              <div className="col-md-12">
                <Accordion activeKey={activeKey}>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header onClick={() => setActiveKey("0")}>
                      <div className="w-100">
                        <div className="hyy">
                          <Link
                            className="holo"
                            onClick={() => { setShowFirst(true); }}
                          >
                            <img src="/assests/images/back.png" alt="Back" />
                          </Link>
                        </div>
                        <div className="w-100">1. Contact information</div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Form>
                        <div className="row g-3 mb-3">
                          <div className="col-md-12">
                            <Form.Group controlId="email">
                              <Form.Label>Email *</Form.Label>
                              <Form.Control
                                type="text"
                                value={inputsche.email}
                                name="email"
                                onChange={handleInputChange}
                                placeholder="email"
                              />
                              {errors.email && (<p className="text-danger">{errors.email}</p>)}
                            </Form.Group>
                          </div>
                          <div className="col-md-12">
                            <Form.Group controlId="name">
                              <Form.Label>First Name *</Form.Label>
                              <Form.Control
                                type="text"
                               value={inputsche.first_name}
                                onChange={handleInputChange}
                                name="first_name"
                                placeholder="First Name"
                              />
                              {errors.first_name && (<p className="text-danger">{errors.first_name}</p>)}
                            </Form.Group>
                          </div>

                          <div className="col-md-12">
                            <Form.Group controlId="name">
                              <Form.Label>Last Name *</Form.Label>
                              <Form.Control
                                type="text"
                               value={inputsche.last_name}
                                onChange={handleInputChange}
                                name="last_name"
                                placeholder="Last Name"
                              />
                              {errors.last_name && (<p className="text-danger">{errors.last_name}</p>)}
                            </Form.Group>
                          </div>
                          
                          <div className="col-md-12">
                            <Form.Group controlId="phone">
                              <Form.Label>Phone Number *</Form.Label>
                              <PhoneInput
                                type="text"
                                name="phone"
                                country={'ie'}
                                placeholder="Enter phone number"
                                inputProps={{
                                  name: 'full_mobile_number',
                                  required: true,
                                  autoFocus: false,
                                }}
                                inputStyle={{ width: '100%' }}
                                value={inputs.full_mobile_number}
                                onChange={(value, countryData = {}, event) => {
                                  const dialCode = countryData.dialCode || '';
                                  // Remove dial code from the value (with '+' just to be safe)
                                  let numberWithoutCode = value;
                                  if (dialCode) {
                                    const cleanDial = `+${dialCode}`;
                                    if (value.startsWith(cleanDial)) {
                                      numberWithoutCode = value.slice(cleanDial.length);
                                    } else if (value.startsWith(dialCode)) {
                                      numberWithoutCode = value.slice(dialCode.length);
                                    }
                                  }
                                  setInputsche({ ...inputsche, country_code: `+${dialCode}`, mobile_number: numberWithoutCode, full_mobile_number: `+${dialCode}${numberWithoutCode}` })
                                }}
                              />
                              {errors.mobile_number && (<p className="text-danger">{errors.mobile_number}</p>)}
                            </Form.Group>
                          </div>
                          <div className="col-md-12">
                            <Form.Group controlId="country">
                              <Form.Label>Country *</Form.Label>
                              <select className="form-control custom-input" name="country_id" value={inputsche.country_id} onChange={handleInputChangeCountry}>
                                <option value="">Country</option>
                                {country.map((val, i) => (
                                <option value={val.id} data-name={val.name}>{val.name}</option>
                                ))}
                              </select>
                              {errors.country_id && (<p className="text-danger">{errors.country_id}</p>)}
                            </Form.Group>
                          </div>
                          <div className="col-md-12">
                            <Form.Group controlId="address">
                              <Form.Label>Street Address *</Form.Label>
                              <Form.Control
                                type="text"
                                value={inputsche.address}
                                name="address"
                                onChange={handleInputChange}
                                placeholder="Street Address"
                              />
                              {errors.address && (<p className="text-danger">{errors.address}</p>)}
                            </Form.Group>
                          </div>
                          <div className="col-md-12">
                            <Form.Group controlId="county">
                              <Form.Label>County *</Form.Label>
                              <Form.Control
                                type="text"
                                value={inputsche.county}
                                name="county"
                                onChange={handleInputChange}
                                placeholder="County"
                              />
                              {errors.county && (<p className="text-danger">{errors.county}</p>)}
                            </Form.Group>
                          </div>
                          
                          <div className="col-md-12">
                            <Form.Group controlId="postcode">
                              <Form.Label>Postcode *</Form.Label>
                              <Form.Control
                              type="text"
                              value={inputsche.postcode}
                              name="postcode"
                              onChange={handleInputChange}
                              placeholder="Post code"
                            />
                            {errors.postcode && (<p className="text-danger">{errors.postcode}</p>)}
                            </Form.Group>
                          </div>
                        </div>


                        <div className="row g-3 ">
                        <div className="col-md-12">
                          <div className="form-check mb-3 d-flex align-items-start sign-ghar mt-3 gap-0">
                            <input
                              type="checkbox"
                              className={`form-check-input`}
                              id="single_event"
                              value={inputsche.single_event ? '1' : ''}
                              checked={inputsche.single_event}
                              onChange={(event) => handleInputChangeCustom('single_event', event.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="single_event">
                              Keep me in the loop with email updates about upcoming YFMF singles events and news. See our <Link to="/privacy-policy" target="_blank" className="text-decoration-none pri-link">Privacy Policy</Link>.
                            </label>
                          </div>
                        </div>
                      </div>
                      {inputsche.single_event && (
                        <>
                        <div className="row g-3">
                          
                          <div className="col-md-6">
                            <Form.Group controlId="lastName">
                              <Form.Label>Location *</Form.Label>
                              <select className="form-control custom-input" name="location" value={inputsche.location} onChange={handleInputChangeLocation}>
                                <option value="">Location</option>
                                {loc.map((val, i) => (
                                <option value={val.id} data-name={val.name}>{val.name}</option>
                                ))}
                              </select>
                              {errors.location && (<p className="text-danger">{errors.location}</p>)}
                            </Form.Group>
                          </div>
                        </div>
                        <div className="row g-3 mt-1">
                          <div className="col-md-6">
                            <Form.Group controlId="firstName">
                              <Form.Label>Gender *</Form.Label>
                              <select className="form-control custom-input" name="gender" value={inputsche.gender} onChange={handleInputChange}>
                                <option value="">Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Non-binary">Non-binary</option>
                              </select>
                              {errors.gender && (<p className="text-danger">{errors.gender}</p>)}
                            </Form.Group>
                          </div>
                          <div className="col-md-6">
                            <Form.Group controlId="lastName">
                              <Form.Label>Birth Year *</Form.Label>
                              <select name="birth_year" id="birth_year" className="form-control custom-input" value={inputsche.birth_year} onChange={handleInputChange}>
                                <option value="">Birth Year </option>
                                {Array.from(
                                  { length: (new Date().getFullYear() - 19) - 1940 + 1 },
                                  (_, i) => 1940 + i
                                ).map((year) => (
                                  <option key={year} value={year}>
                                    {year}
                                  </option>
                                ))}
                            </select>
                              {errors.birth_year && (<p className="text-danger">{errors.birth_year}</p>)}
                            </Form.Group>
                          </div>
                        </div>
                        </>
                      )}


                      </Form>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>

            <div className="row pb-4">
              <div className="col-md-12">
                <Button
                  className="mt-4 w-100 ne"
                  onClick={nextStep1}
                >
                  Confirm - next step
                </Button>
              </div>
            </div>
          </div>
        )}

        {currentStep === 3 && (
          <div className="container-fluid out d-flex flex-column vh-100">
            <div className="row text-center mb-5">
              <img src="/assests/images/back-top-logo.png" alt="back-logo" />
            </div>

            <div className="row flex-grow-1">
              <div className="col-md-12">
                <Accordion activeKey={activeKey}>
                  <Accordion.Item eventKey="1">
                    <div className="hyy">
                      <Link
                        className="holo"
                        onClick={() => { setShowFirst(true); }}
                      >
                        <img src="/assests/images/back.png" alt="Back" />
                      </Link>
                    </div>
                    <Accordion.Header>2. Payment</Accordion.Header>
                    <Accordion.Body>
                      <Elements stripe={stripePromise}>
                      <CheckoutForm inputs={inputs} inputsche={inputsche} qty={qty} />
                    </Elements>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>
          </div>
        )}
      </div>
      {loading && (
         <div className="loadingClass">
          <img src={loader} alt="loader"/>
        </div>
      )} 
    </>
  );
};

export default CheckOutCall;